import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { ArrowLeft } from 'lucide-react';

const Login = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/chat');
    }
  }, [isAuthenticated, navigate]);

  const handleGoogleLogin = async () => {
    try {
      await login('Google');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="login-container">
      <button onClick={() => navigate('/')} className="back-to-home">
        <ArrowLeft size={20} />
        <span>Back to Home</span>
      </button>

      <div className="login-content">
        <Card className="login-card">
          <CardHeader>
            <div className="login-header">
              <div className="logo-text">WestBay</div>
              <CardTitle className="login-title">Sign in to Poser AI™ <span className="patent-small">Patent Pending</span></CardTitle>
              <p className="login-subtitle">
                Access our Cloud Solutions Architect AI assistant
              </p>
            </div>
          </CardHeader>
          <CardContent className="login-card-content">
            <div className="login-poser-preview">
              <img src="/poser-ai-hero.png" alt="Poser AI" className="login-poser-image" />
            </div>
            <div className="login-info">
              <p>🔒 Secure authentication with Google</p>
              <p>🤖 AI-powered by AWS Bedrock & Claude 4.5 • 👥 Backed up by human interaction</p>
              <p>📊 Personalized conversation history</p>
            </div>

            <button onClick={handleGoogleLogin} className="google-signin-btn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              <span>Continue with Google</span>
            </button>

            <div className="login-note">
              <p className="note-text">
                Note: New accounts require admin approval before accessing Poser AI™.
                You'll be notified via email once approved.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Login;